/* tslint:disable */
/* eslint-disable */
export enum PaymentOrderBy {
  Amount = 'Amount',
  DateAndTime = 'DateAndTime',
  PayerName = 'PayerName',
  CardNumber = 'CardNumber',
  TransactionType = 'TransactionType'
}
